import PageTitle from "@/components/PageTitle";

type ObjectHeadingWrapper = {
  title: string;
};

export const ObjectHeadingWrapper = ({ title }: ObjectHeadingWrapper) => {
  return (
    <>
      <PageTitle pattern={`/sections/:sectionId/change-requests`} title={`Jobs | ${title}`} />
    </>
  );
};

type Props = {
  title?: string;
};

export function JobsHeader({ title }: Props) {
  return (
    <div data-testid="person-details-header">
      <ObjectHeadingWrapper title={title || "Jobs"} />
    </div>
  );
}

JobsHeader.defaultProps = {
  backLink: { to: "/jobs" }
};
